import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = ({ type = 'organization' }) => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "Prabhat Tara Vidya Niketan",
    "alternateName": "PTVN Goraul",
    "url": "https://prabhattaravidyaniketan.in",
    "logo": "https://prabhattaravidyaniketan.in/images/logo.jpg",
    "description": "Prabhat Tara Vidya Niketan is a premier educational institution with 30+ years of excellence, affiliated with Bihar Government, providing quality education from LKG to Class 10.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rajkhand, Goraul",
      "addressLocality": "Vaishali",
      "addressRegion": "Bihar",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-7654164726",
      "contactType": "Admissions",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi"]
    },
    "sameAs": [
      "https://www.facebook.com/profile.php?id=61562571579177",
      "https://www.instagram.com/prabhattaravidyaniketan/",
      "https://www.youtube.com/@ptvn_goraul"
    ],
    "founder": {
      "@type": "Person",
      "name": "Shubh Nath Singh"
    },
    "foundingDate": "1995",
    "alumni": [],
    "numberOfStudents": {
      "@type": "QuantitativeValue",
      "value": "500+"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://prabhattaravidyaniketan.in/"
      }
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Prabhat Tara Vidya Niketan",
    "url": "https://prabhattaravidyaniketan.in",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://prabhattaravidyaniketan.in/search?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "School",
    "name": "Prabhat Tara Vidya Niketan",
    "image": "https://prabhattaravidyaniketan.in/images/logo.jpg",
    "@id": "https://prabhattaravidyaniketan.in",
    "url": "https://prabhattaravidyaniketan.in",
    "telephone": "+91-7654164726",
    "priceRange": "₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rajkhand, Goraul",
      "addressLocality": "Vaishali",
      "addressRegion": "Bihar",
      "postalCode": "844114",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 25.9871,
      "longitude": 85.3462
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "opens": "08:00",
      "closes": "14:00"
    }
  };

  const getSchemas = () => {
    switch (type) {
      case 'home':
        return [organizationSchema, websiteSchema, localBusinessSchema, breadcrumbSchema];
      case 'breadcrumb':
        return [breadcrumbSchema];
      default:
        return [organizationSchema];
    }
  };

  return (
    <Helmet>
      {getSchemas().map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default StructuredData;
